import { Injectable, Inject } from '@angular/core';
// import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalCustomNavigationClient } from '@azure/msal-angular';
import { AccountInfo, AuthError, AuthenticationResult, BrowserAuthError, CacheLookupPolicy, EventMessage, EventType, InteractionRequiredAuthError, InteractionStatus, PopupRequest, RedirectRequest, ServerError } from '@azure/msal-browser';
//import { User, CacheResult, UserAgentApplication } from 'msal';
import { MSALError } from './MsalFlowInterceptor';
import { ApplicationInsightsService } from './application-insights.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
//import { TokenCache } from '@azure/msal-browser/dist/cache/TokenCache';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { environment } from '../../environments/environment';

export type ReauthReason = 'interaction-required' | 'consent-required' | 'token-expired' | 'no-account';

export interface ReauthPrompt {
  reason: ReauthReason;
  title: string;
  message: string;
  actionLabel: string;
  resource?: string;
  scopes?: string[];
}

const REAUTH_ROUTE_FALLBACK_KEY = 'flowstudio.lastRoute';
const REAUTH_PROMPT_COOLDOWN_MS = 30000;
const REAUTH_PROMPT_DELAY_MS = 5000;
const REAUTH_PROMPT_MODAL_DELAY_MS = 30000;

// Non-HttpOnly hint cookie scoped to the parent registrable domain (visible to
// flowstudio.app + dev.flowstudio.app + prod.flowstudio.app) so the marketing
// site can personalize ("Welcome back, X — continue to your dashboard") without
// probing this app's /.auth/me (which is meaningless under MSAL). Treat as
// advisory only — actual auth still lives in MSAL tokens.
const SIGNED_IN_HINT_COOKIE = 'fs_user';
const SIGNED_IN_HINT_COOKIE_MAX_AGE = 60 * 60 * 24 * 30;
const SIGNED_IN_HINT_COOKIE_DOMAIN = 'flowstudio.app';

@Injectable({
  providedIn: 'root'
})
export class MsalHelperService {

  // api = false;
  error: MSALError = null;
  user$ = new BehaviorSubject<AccountInfo>(null);
  token$ = new BehaviorSubject(null);
  tokenAdmin$ = new BehaviorSubject(null);
  reauthCompleted$ = new BehaviorSubject<number>(0);
  reauthPrompt$ = new BehaviorSubject<ReauthPrompt | null>(null);
  reauthPromptModal$ = new BehaviorSubject<ReauthPrompt | null>(null);

  badloop = 0;
  private reauthSuppressUntil = 0;
  private pendingReauthPrompt: ReauthPrompt | null = null;
  private reauthPromptTimer: number | null = null;
  private reauthModalTimer: number | null = null;
  private reauthFlowActive = false;
  // previous_scope = [];

  constructor(
    private msalService: MsalService,
    private broadcastService: MsalBroadcastService,
    private router: Router,
    private location: Location,
    private angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration
  ) {

    // (this.msalService as any)['_redirectUri'] = `${window.location.origin}/token`;
    // (this.msalService as any)['_postLogoutRedirectUri'] = `${window.location.origin}/welcome`;

    const customNavigationClient = new MsalCustomNavigationClient(this.msalService, this.router, this.location);
    this.msalService.instance.setNavigationClient(customNavigationClient);

    this.msalService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.broadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      )
      .subscribe((result: EventMessage) => {
        if (this.msalService.instance.getAllAccounts().length === 0) {
          this.clearSignedInHintCookie();
          // debugger
          // window.location.pathname = "/";
        } else {
          //this.setLoginDisplay();
        }
      });

    this.broadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) =>
          msg.eventType === EventType.LOGIN_SUCCESS ||
          msg.eventType === EventType.LOGIN_FAILURE ||
          msg.eventType === EventType.ACCOUNT_ADDED ||
          msg.eventType === EventType.ACCOUNT_REMOVED ||
          msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE ||
          msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
        )
      ).subscribe((result: EventMessage) => {
        this.logMsalEvent(result);

        if (result.eventType === EventType.LOGIN_SUCCESS && result.payload) {
          const authResult = result.payload as AuthenticationResult;
          if (authResult.account) {
            this.msalService.instance.setActiveAccount(authResult.account);
          }
          this.clearReauthPrompt();
          this.getUser();
          this.refreshPowerTokenAfterLogin(authResult);
          this.markReauthCompleted();
        }

        if (this.msalService.instance.getAllAccounts().length === 0) {
          // Account logged out in a different tab, redirect to homepage
          //window.location.pathname = "/";
        } else {
          // Update UI to show user is signed in. result.payload contains the account that was logged in
        }
        this.error = (result.error || result.payload) as MSALError;
        // if (result.eventType === EventType.ACQUIRE_TOKEN_START) {
        //   if ('scopes' in result.payload as any) {
        //     this.previous_scope == result.payload['scopes'];
        //   }
        // }
        if (result.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
          if (this.error instanceof InteractionRequiredAuthError) {
            this.requestReauthPrompt(this.error);
          }
          if (this.error instanceof BrowserAuthError && this.error.subError == "bad_token") {
            router.navigate(['/login-failed'], {queryParams: { 'why': 'BadToken' }, queryParamsHandling:'merge' });
            //window.location.pathname = "/login-failed";
            return;
          }
          if (this.error instanceof ServerError) {
            router.navigate(['/login-failed'], {queryParams: { 'why': 'ServerError' }, queryParamsHandling:'merge' });
            //window.location.pathname = "/login-failed";
            return;
          }
          if (result.error instanceof DOMException) {
            if (result.error.name == "QuotaExceededError") {
              // either large cache, or some sort of infinite loop has caused localstorage to be filled up.
              // const cache = this.msalService.instance.getTokenCache() as TokenCache;
              // force clear all the local storage values
              router.navigate(['/login-failed'], {queryParams: { 'why': 'QuotaExceededError' }, queryParamsHandling:'merge' });
              // localStorage.clear();
              return;
            }
          }

          // Unhandled token failure — show reauth banner as catch-all
          // Covers ClientAuthError (token_refresh_required) and other non-specific failures
          this.requestReauthPrompt(this.error);
          return;
        }
        if (result.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
          this.badloop = 0;
          this.error = null;
          this.clearReauthPrompt();
          this.msalService.instance.setActiveAccount(result.payload['account'] as AccountInfo);      
          this.getUser();
          this.markReauthCompleted();
        }
      });
    
    // this.user$.subscribe(
    //   (user)=>{
    //     this.verifyApi();
    //   }
    // )

    // this.broadcastService.inProgress$
    //   .pipe(
    //       filter((status:InteractionStatus)=> status === InteractionStatus.None)
    //       //takeUntil(this._destroying$)
    //   )
    //   .subscribe(()=>{
    //       console.log("login success ");
    //       //this.loggedIn = true;

    //       this.verifyUser(); 
    //       if (!this.loggedIn) {
    //           // user login issue
    //           this.router.navigate(['/']);
    //       }                   
    //   });

    //this.msalService.handleRedirectObservable().subscribe();
    /*
    this.msalService.instance.handleRedirectPromise().then(authResult=>{
      const account = this.msalService.instance.getActiveAccount();
      if (!account) {
        //msalService.loginRedirect();
      }      
    }).catch((error)=>{
      // console.log(`redirect to /`)
      // debugger
      // window.location.pathname = "/";
    })
    */
    // this.broadcastService.subscribe("msal:loginFailure", (payload) => {
    //   // do something here
    //   console.log(payload);
    //   this.error = payload as MSALError;

    //   if (this.error.error != "access_denied") {
    //     //this.badloop++;
    //     //this.login();
    //   }
    //   //this.loginRedirect();
    // });
    // this.broadcastService.subscribe("msal:acquireTokenSuccess", (payload) => {
    //   this.badloop = 0;
    //   this.error = null;
    //   console.log(`badloop: ${this.badloop}`);
    // });
    // this.broadcastService.subscribe("msal:acquireTokenFailure", (payload) => {
    //   console.log(payload);
    //   this.error = payload as MSALError;

    //   if (this.error.errorDesc === "consent_required") {
    //     this.loginPowerConsent();
    //   }
    //   else {
    //     //this.badloop++;
    //     //this.login();
    //   }
    // });

    // this.verifyApi();
  }

  // async verifyApi() {

    //let setting = await this.storageDexieService.getSetting(Settings.SETTING_USEAPI);
    //this.api = (setting.value == true);
    // this.api = false;
    // this.token$.next(this.getCachedTokenInternal(['https://service.flow.microsoft.com//Flows.Read.All']));
    // //debugger
    // this.tokenAdmin$.next(this.getCachedTokenInternal(['https://service.flow.microsoft.com//User']));

    // let ARMClientID = '91723a5f-ef28-4393-aa4f-7bbc3379f131';
    // let FlowClientID = '7f4aaf40-bd90-4647-ae9d-d31472f32c86';
    // //FlowClientID = 'c82e86bb-56f6-4ac1-953f-0b950ac6570d';

    // if (this.api) {
    //   (this.msalService as any)['clientId'] = FlowClientID;
    // }
    // else {
    //   (this.msalService as any)['clientId'] = ARMClientID;
    // }
    //debugger
  // }

  private getSignedInHintCookieDomain(): string | null {
    const host = window.location.hostname;
    if (host === SIGNED_IN_HINT_COOKIE_DOMAIN || host.endsWith(`.${SIGNED_IN_HINT_COOKIE_DOMAIN}`)) {
      return SIGNED_IN_HINT_COOKIE_DOMAIN;
    }
    return null;
  }

  private setSignedInHintCookie(account: AccountInfo): void {
    const domain = this.getSignedInHintCookieDomain();
    if (!domain) return;
    const email = account?.username || '';
    if (!email) {
      this.clearSignedInHintCookie();
      return;
    }
    const value = encodeURIComponent(email);
    document.cookie = `${SIGNED_IN_HINT_COOKIE}=${value}; domain=${domain}; path=/; max-age=${SIGNED_IN_HINT_COOKIE_MAX_AGE}; secure; samesite=lax`;
  }

  private clearSignedInHintCookie(): void {
    const domain = this.getSignedInHintCookieDomain();
    if (!domain) return;
    document.cookie = `${SIGNED_IN_HINT_COOKIE}=; domain=${domain}; path=/; max-age=0; secure; samesite=lax`;
  }

  /**
   * Clear MSAL's stale "interaction.status" flag before a user-initiated
   * interactive call. A previous redirect that didn't fully round-trip (user
   * navigated away mid-flow, closed the tab, refreshed, etc.) leaves the flag
   * set, which causes the next loginRedirect / acquireTokenRedirect to throw
   * BrowserAuthError: interaction_in_progress. The user just clicked Sign in /
   * Re-authenticate, so dropping the previous interaction is the right move.
   *
   * Only call this for user-initiated paths — interceptor-driven redirects
   * should let MSAL's normal lifecycle handle the flag.
   */
  private clearStaleInteractionState(): void {
    // MSAL stores its "in-flight redirect" state in either localStorage (when
    // the app sets `temporaryCacheLocation: BrowserCacheLocation.LocalStorage`
    // — FlowStudio does) or sessionStorage (the default). When a redirect is
    // abandoned (closed AAD tab, navigated away mid-flow, etc.) these entries
    // persist and block the next interactive call with
    // `BrowserAuthError: interaction_in_progress`.
    //
    // We don't go through MSAL's `instance.browserStorage` API — that property
    // isn't exposed publicly on the PublicClientApplication wrapper, so the
    // call silently no-ops. Read/write the raw browser storage instead.
    //
    // Only touch in-flight request state. Never touch accounts, tokens, or
    // refresh tokens (those use different key formats).
    const inflightPatterns = [
      'interaction.status',           // msal.interaction.status (the actual flag)
      '.request.origin',              // msal.<clientId>.request.origin
      '.request.params',              // msal.<clientId>.request.params
      '.request.state.',              // msal.<clientId>.request.state.<id>
      '.request.correlationId',       // msal.<clientId>.request.correlationId
      '.nonce.id_token.',             // msal.<clientId>.nonce.id_token.<id>
      '.authority.',                  // msal.<clientId>.authority.<id>
      '.ccs.credential',              // msal.<clientId>.ccs.credential
    ];

    for (const storage of [window.localStorage, window.sessionStorage]) {
      try {
        const keys: string[] = [];
        for (let i = 0; i < storage.length; i++) {
          const key = storage.key(i);
          if (key && inflightPatterns.some((p) => key.includes(p))) keys.push(key);
        }
        keys.forEach((k) => storage.removeItem(k));
      } catch {
        // ignore privacy-mode / quota errors
      }
    }
  }

  private safeLoginRedirect(request: RedirectRequest): void {
    console.log('[MsalHelper] loginRedirect.start', {
      redirectUri: request.redirectUri,
      redirectStartPage: request.redirectStartPage,
      scopes: this.sanitizeScopes(request.scopes),
      accountCount: this.msalService.instance.getAllAccounts().length,
      hasActiveAccount: !!this.msalService.instance.getActiveAccount()
    });
    this.clearStaleInteractionState();
    this.msalService.loginRedirect(request);
  }

  login() {

    if (this.badloop > 2) {
      return;
    }

    //debugger

    // this.storageDexieService.getSetting(Settings.SETTING_USEAPI).then(setting => {
    //   this.api = (setting.value == true);

    //   if (this.api) {
    //     this.msalService.loginRedirect([
    //       //'offline_access',
    //       'https://service.flow.microsoft.com/Flows.Read.All',
    //       'https://service.flow.microsoft.com/Flows.Manage.All',
    //       'https://service.flow.microsoft.com/Activity.Read.All',
    //       'https://service.flow.microsoft.com/Approvals.Read.All',
    //       'https://service.flow.microsoft.com/Approvals.Manage.All',
    //       'https://service.powerapps.com/User'
    //       //'https://graph.microsoft.com/offline_access'
    //     ]);
    //   }
    //   else {

    this.safeLoginRedirect({
      scopes: [
        "profile", "offline_access"
      ],
      redirectUri: `${window.location.origin}/token`,

      // extraScopesToConsent: [
      //   'https://service.flow.microsoft.com/Flows.Read.All',
      //   'https://service.flow.microsoft.com/Flows.Manage.All',
      //   'https://service.flow.microsoft.com/Activity.Read.All',
      //   'https://service.flow.microsoft.com/Approvals.Read.All',
      //   'https://service.flow.microsoft.com/Approvals.Manage.All',
      //   'https://service.powerapps.com/User'
      // ]
    });
      // if (this.msalGuardConfig.authRequest) {

      //   this.msalService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
      // }
      // else {
      //   //this.clearLocalStorage();
      //   //this.loginPowerConsent();
      // }

        // this.msalService.loginRedirect([
        //   'https://management.azure.com//user_impersonation',
        //   // 'offline_access',
        //   // 'https://service.flow.microsoft.com/Flows.Read.All',
        //   // 'https://service.flow.microsoft.com/Flows.Manage.All',
        //   // 'https://service.flow.microsoft.com/Activity.Read.All',
        //   // 'https://service.flow.microsoft.com/Approvals.Read.All',
        //   // 'https://service.flow.microsoft.com/Approvals.Manage.All'

        //   // 'https://graph.microsoft.com/offline_access'
        // ]);
    //  }
    //});
  }

  // loginRedirect(): void {
  //   this.msalService.loginRedirect([
  //     'https://management.azure.com//user_impersonation',
  //   ]);
  // }

  // loginConsent(): void {
  //   this.msalService.loginRedirect([
  //     'https://management.azure.com//user_impersonation',
  //   ],'&prompt=consent');
  // }

  loginDynamicsConsent(url: string): void {
    this.safeLoginRedirect({
      scopes: [
        `${url || 'https://services.crm.dynamics.com'}/user_impersonation`,
        //`${url}/user_impersonation`,
        "offline_access"
      ],
      redirectUri: `${window.location.origin}/token`,
      //extraQueryParameters: { prompt: 'consent' }
    });
  }

  private getPowerLoginScopes(): string[] {
    return [
      'https://service.flow.microsoft.com//Flows.Manage.All',
      'https://service.flow.microsoft.com//Activity.Read.All',
      'https://service.flow.microsoft.com//Approvals.Manage.All',
    ];
  }

  private getPowerAppsLoginScopes(): string[] {
    return [
      'https://service.powerapps.com/User',
    ];
  }

  private getWelcomeLoginScopes(): string[] {
    const scopes = [
      'profile',
      'offline_access',
      ...this.getPowerLoginScopes()
    ];

    if (this.hasCachedPowerAutomateAdminGrant()) {
      scopes.push('https://service.flow.microsoft.com//User');
    }

    return [...new Set(scopes)];
  }

  private getCachedWelcomeRefreshScopes(): string[] {
    const scopes = [
      'profile',
      'offline_access',
    ];

    if (this.getCachedTokenInternalPowerAutomate()?.secret) {
      scopes.push(...this.getPowerLoginScopes());
    }

    if (this.hasCachedPowerAutomateAdminGrant()) {
      scopes.push('https://service.flow.microsoft.com//User');
    }

    return [...new Set(scopes)];
  }

  private hasCachedPowerAutomateAdminGrant(): boolean {
    return !!this.getCachedTokenInternal(['https://service.flow.microsoft.com//User'])?.secret;
  }

  private getActiveAccount(): AccountInfo | null {
    return this.msalService.instance.getActiveAccount() ?? this.msalService.instance.getAllAccounts()[0] ?? null;
  }

  private async trySilentReauth(scopes: string[]): Promise<boolean> {
    const account = this.getActiveAccount();
    if (!account) {
      return false;
    }

    try {
      const result = await firstValueFrom(this.msalService.acquireTokenSilent({
        scopes,
        account,
        forceRefresh: true,
        cacheLookupPolicy: CacheLookupPolicy.RefreshTokenAndNetwork,
      }));

      if (result?.account) {
        this.msalService.instance.setActiveAccount(result.account as AccountInfo);
        this.getUser();
      }

      return !!result?.accessToken;
    }
    catch {
      return false;
    }
  }

  private refreshPowerTokenAfterLogin(authResult?: AuthenticationResult): void {
    const grantedScopes = (authResult?.scopes || []).map((scope) => `${scope}`.toLowerCase());
    const shouldRefreshPowerToken = grantedScopes.some((scope) =>
      scope.includes('service.flow.microsoft.com') ||
      scope === 'flows.manage.all' ||
      scope === 'activity.read.all' ||
      scope === 'approvals.manage.all'
    );

    if (!shouldRefreshPowerToken) {
      return;
    }

    // Power Automate refresh — fold in the admin scope when the user has
    // already granted it, so the admin (User) token is warmed up alongside the
    // base Flows/Activity/Approvals scopes in a single silent acquire.
    const paScopes = [...this.getPowerLoginScopes()];
    if (this.hasCachedPowerAutomateAdminGrant()) {
      paScopes.push('https://service.flow.microsoft.com//User');
    }

    this.trySilentReauth(paScopes).then((ok) => {
      if (ok) {
        this.clearReauthPrompt();
      }
    });

    // If a Power Apps token was previously acquired (i.e. the user has visited
    // /connections or /powerapps before), pre-warm it silently in parallel.
    // Best-effort: failures here are silent — the page will fall through to a
    // live acquire if the cache happens to be stale.
    if (this.getCachedTokenInternalPowerApps()?.secret) {
      this.trySilentReauth(['https://service.powerapps.com/User'])
        .catch(() => { /* best-effort pre-warm */ });
    }
  }

  public async reauthPowerLogin(): Promise<boolean> {
    const scopes = this.getPowerLoginScopes();
    if (await this.trySilentReauth(scopes)) {
      this.clearReauthPrompt();
      return true;
    }

    this.requestReauthPrompt(this.error);
    return false;
  }

  public async trySilentPowerTokens(): Promise<boolean> {
    const account = this.getActiveAccount();
    if (!account) return false;
    const scopes = [...this.getPowerLoginScopes()];
    if (this.hasCachedPowerAutomateAdminGrant()) {
      scopes.push('https://service.flow.microsoft.com//User');
    }
    try {
      const result = await firstValueFrom(this.msalService.acquireTokenSilent({ scopes, account }));
      return !!result?.accessToken;
    } catch {
      return false;
    }
  }

  public async trySilentPowerAppsToken(): Promise<boolean> {
    return this.trySilentReauth(this.getPowerAppsLoginScopes());
  }

  public async trySilentM365Tokens(): Promise<{ flow: boolean; powerApps: boolean }> {
    const [flow, powerApps] = await Promise.all([
      this.trySilentPowerTokens(),
      this.trySilentPowerAppsToken(),
    ]);

    return { flow, powerApps };
  }

  public beginReauthFromBanner(): void {
    const redirectStartPage = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const route = redirectStartPage || '/flows';

    this.reauthSuppressUntil = Date.now() + REAUTH_PROMPT_COOLDOWN_MS;

    try {
      window.sessionStorage.setItem(REAUTH_ROUTE_FALLBACK_KEY, route);
      window.localStorage.setItem(REAUTH_ROUTE_FALLBACK_KEY, route);
    } catch {
      // ignore quota/privacy mode errors
    }

    this.clearReauthPrompt();
    this.reauthFlowActive = true;
    this.loginPowerLogin(route);
  }

  private markReauthCompleted(): void {
    if (!this.reauthFlowActive) {
      return;
    }

    this.reauthFlowActive = false;
    this.reauthCompleted$.next(this.reauthCompleted$.value + 1);
  }

  public clearReauthPrompt(): void {
    if (this.reauthPromptTimer !== null) {
      window.clearTimeout(this.reauthPromptTimer);
      this.reauthPromptTimer = null;
    }

    if (this.reauthModalTimer !== null) {
      window.clearTimeout(this.reauthModalTimer);
      this.reauthModalTimer = null;
    }

    this.pendingReauthPrompt = null;
    this.reauthPrompt$.next(null);
    this.reauthPromptModal$.next(null);
  }

  public requestReauthPrompt(error?: any, scopes: string[] = []): ReauthPrompt {
    if (Date.now() < this.reauthSuppressUntil) {
      return this.reauthPrompt$.value ?? this.pendingReauthPrompt;
    }

    const prompt = this.buildPrompt(error, scopes);
    const current = this.reauthPrompt$.value;
    if (current && current.reason === prompt.reason && current.message === prompt.message) {
      return current;
    }

    this.pendingReauthPrompt = prompt;

    if (this.reauthPromptTimer === null) {
      this.reauthPromptTimer = window.setTimeout(() => {
        this.reauthPromptTimer = null;

        if (Date.now() < this.reauthSuppressUntil) {
          this.pendingReauthPrompt = null;
          return;
        }

        if (this.pendingReauthPrompt) {
          this.reauthPrompt$.next(this.pendingReauthPrompt);
        }
      }, REAUTH_PROMPT_DELAY_MS);
    }

    if (this.reauthModalTimer === null) {
      this.reauthModalTimer = window.setTimeout(() => {
        this.reauthModalTimer = null;

        if (Date.now() < this.reauthSuppressUntil) {
          return;
        }

        const current = this.reauthPrompt$.value ?? this.pendingReauthPrompt;
        if (current) {
          this.pendingReauthPrompt = null;
          this.reauthPromptModal$.next(current);
        }
      }, REAUTH_PROMPT_MODAL_DELAY_MS);
    }

    return prompt;
  }

  private describeScopes(scopes: string[] = []): string {
    if (!scopes.length) {
      return 'Microsoft sign-in token';
    }

    const labels = scopes.map((scope) => {
      const lower = `${scope}`.toLowerCase();
      if (lower.includes('service.flow.microsoft.com')) {
        const permission = `${scope}`.split('/').filter(Boolean).pop();
        return `Power Automate${permission ? ` (${permission})` : ''}`;
      }
      if (lower.includes('service.powerapps.com')) {
        const permission = `${scope}`.split('/').filter(Boolean).pop();
        return `Power Apps${permission ? ` (${permission})` : ''}`;
      }
      if (lower.includes('graph.microsoft.com')) {
        const permission = `${scope}`.split('/').filter(Boolean).pop();
        return `Microsoft Graph${permission ? ` (${permission})` : ''}`;
      }
      if (lower.startsWith('api://')) {
        const permission = `${scope}`.split('/').filter(Boolean).pop();
        return `FlowStudio API${permission ? ` (${permission})` : ''}`;
      }
      return scope;
    });

    return [...new Set(labels)].join(', ');
  }

  private withResource(prompt: ReauthPrompt, scopes: string[]): ReauthPrompt {
    const resource = this.describeScopes(scopes);
    return {
      ...prompt,
      resource,
      scopes,
      message: `${prompt.message} Needed resource: ${resource}.`
    };
  }

  private buildPrompt(error?: any, scopes: string[] = []): ReauthPrompt {
    const subError = (error as any)?.subError || (error as any)?.errorCode || (error as any)?.error?.error?.code;
    if (subError === 'consent_required') {
      return this.withResource({
        reason: 'consent-required',
        title: 'Consent required',
        message: 'FlowStudio needs a fresh Microsoft consent grant before it can continue. Click Re-authenticate to approve it.',
        actionLabel: 'Re-authenticate'
      }, scopes);
    }

    if (error instanceof InteractionRequiredAuthError) {
      return this.withResource({
        reason: 'interaction-required',
        title: 'Sign-in required',
        message: 'FlowStudio could not refresh your sign-in silently. Click Re-authenticate to continue.',
        actionLabel: 'Re-authenticate'
      }, scopes);
    }

    return this.withResource({
      reason: 'token-expired',
      title: 'Sign-in expired',
      message: 'FlowStudio could not refresh your token silently. Click Re-authenticate to sign in again.',
      actionLabel: 'Re-authenticate'
    }, scopes);
  }

  loginPowerLogin(redirectStartPage?: string): void {
    this.safeLoginRedirect({
      scopes: this.getPowerLoginScopes(),
      redirectUri: `${window.location.origin}/token`,
      redirectStartPage: redirectStartPage || window.location.href
      //extraQueryParameters: { prompt: 'consent' }
    });
  }

  loginPowerConsent(): void {
    this.loginPowerLogin();
  }

  loginM365Consent(redirectStartPage?: string): void {
    this.safeLoginRedirect({
      scopes: this.getPowerLoginScopes(),
      redirectUri: `${window.location.origin}/token`,
      redirectStartPage: redirectStartPage || window.location.href
    });
  }

  welcomeLogin(redirectStartPage: string = '/flows'): void {
    this.safeLoginRedirect({
      scopes: this.getWelcomeLoginScopes(),
      redirectUri: `${window.location.origin}/token`,
      redirectStartPage
    });
  }

  continueLogin(redirectStartPage: string = '/flows'): void {
    const scopes = this.getCachedWelcomeRefreshScopes();
    this.safeLoginRedirect({
      scopes,
      redirectUri: `${window.location.origin}/token`,
      redirectStartPage
    });
  }

  loginPowerAdmin(): void {
    this.safeLoginRedirect({
      scopes: [
        // 'https://management.azure.com/user_impersonation',
        // 'offline_access',
        // 'https://service.flow.microsoft.com//Flows.Read.All',
        'https://service.flow.microsoft.com//Flows.Manage.All',
        'https://service.flow.microsoft.com//Activity.Read.All',
        // 'https://service.flow.microsoft.com//Approvals.Read.All',
        'https://service.flow.microsoft.com//Approvals.Manage.All',
        'https://service.flow.microsoft.com//User',
        //'https://service.powerapps.com/User',

        // 'https://graph.microsoft.com/offline_access'
      ],
      redirectUri: `${window.location.origin}/token`,
    });
  }

  loginPowerAppConsent(): void {
    this.safeLoginRedirect({
      scopes: [
        'https://service.powerapps.com/User',
        //'offline_access',
        //'https://service.powerapps.com/Apps.Read.All',
        //'https://service.powerapps.com/Apps.Manage.All',
        //'https://service.powerapps.com//Activity.Read.All',
        //'https://service.powerapps.com//Approvals.Read.All',
        //'https://service.powerapps.com//Approvals.Manage.All'

        // 'https://graph.microsoft.com/offline_access'
      ],
      redirectUri: `${window.location.origin}/token`,
      //extraQueryParameters: { prompt: 'consent' }
    });
  }

  loginDefault(): void {
    this.safeLoginRedirect({
      scopes: [
        `api://91723a5f-ef28-4393-aa4f-7bbc3379f131/.default`,
      ],
      redirectUri: `${window.location.origin}/token`,
      extraQueryParameters: { prompt: 'consent' }
    });
  }

  logout(): void {
    this.clearSignedInHintCookie();
    this.msalService.logout();
  }

  getUser(): AccountInfo {
    //const user = this.msalService.getUser();
    // let activeAccount:AccountInfo = null;
    let activeAccount = this.msalService.instance.getActiveAccount();
    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      let accounts = this.msalService.instance.getAllAccounts();
      activeAccount = accounts[0];
      this.msalService.instance.setActiveAccount(activeAccount);
    }

    if (activeAccount) {
      activeAccount['tid'] = activeAccount.idTokenClaims['tid'];
      activeAccount['oid'] = activeAccount.idTokenClaims['oid'];
      identify(activeAccount);

      this.angulartics2GoogleTagManager.setUsername(`${activeAccount['tid']}.${activeAccount['oid']}`)
      this.setSignedInHintCookie(activeAccount);
    } else {
      this.clearSignedInHintCookie();
    }
    this.user$.next(activeAccount);
    return activeAccount;
  }

  clearLocalStorage() {
    Object.keys(window.localStorage).forEach((key)=>{
      if (key.startsWith('msal.acquireTokenUser') || key.startsWith('msal.token.renew')) {
        window.localStorage.removeItem(key)
      }
    })
  }
  async ensureToken(API_ROOT: string) {
    var scopes = this.getScopesForEndpoint(API_ROOT);
    // var token = await this.msalService.acquireTokenSilent({
    //   scopes
    // });
  }

  private isTokenUsable(secret: string | null | undefined, skewSeconds = 60): boolean {
    if (!secret) {
      return false;
    }

    try {
      const payload = this.decodeJwtPayload(secret);
      if (!payload) return false;

      if (!payload?.exp) {
        return true;
      }

      const now = Math.floor(Date.now() / 1000);
      return payload.exp > (now + skewSeconds);
    } catch {
      return false;
    }
  }

  private decodeJwtPayload(secret: string): any | null {
    const parts = secret.split('.');
    if (parts.length < 2 || !parts[1]) return null;

    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const bytes = Uint8Array.from(atob(padded), c => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  }

  private findCachedTokenRecord(scopes: string[]): { key: string; value: any } | null {
    const auth = this.msalService.instance.getConfiguration().auth;
    const { clientId } = auth;
    const search = scopes.join(' ');

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.includes(`-accesstoken-${clientId}`.toLowerCase()) && key.includes(`${search}`.toLowerCase())) {
        const raw = localStorage.getItem(key);
        if (!raw) {
          continue;
        }

        try {
          return { key, value: JSON.parse(raw) };
        } catch {
          localStorage.removeItem(key);
          return null;
        }
      }
    }

    return null;
  }

  private refreshTokenInBackground(scopes: string[]): void {
    void firstValueFrom(this.getAccessTokenSilent$(scopes, true)).catch(() => null);
  }

  getCachedTokenInternal(scopes: string[]) /*: CacheResult */ {
    const cached = this.findCachedTokenRecord(scopes);
    if (!cached) {
      return null;
    }

    if (this.isTokenUsable(cached.value?.secret)) {
      return cached.value;
    }

    localStorage.removeItem(cached.key);
    this.refreshTokenInBackground(scopes);

    return null;
  }

  async getCachedTokenInternalAsync(scopes: string[]) {
    const cached = this.getCachedTokenInternal(scopes);
    if (cached?.secret) {
      return cached;
    }

    try {
      const acquired = await firstValueFrom(this.getAccessTokenSilent$(scopes));
      if (this.isTokenUsable(acquired?.accessToken)) {
        return {
          secret: acquired.accessToken,
          expiresOn: acquired.expiresOn?.toISOString?.() || null,
        };
      }
    } catch {
      // Try forced refresh next.
    }

    try {
      const refreshed = await firstValueFrom(this.getAccessTokenSilent$(scopes, true));
      if (this.isTokenUsable(refreshed?.accessToken)) {
        return {
          secret: refreshed.accessToken,
          expiresOn: refreshed.expiresOn?.toISOString?.() || null,
        };
      }
    } catch {
      return null;
    }

    return null;
  }

  getCachedTokenInternalPowerApps() {
    return this.getCachedTokenInternal(['https://service.powerapps.com/User']);
  }

  getCachedTokenInternalPowerAutomate() {
    return this.getCachedTokenInternal(['https://service.flow.microsoft.com//Flows.Manage.All']);
  }

  getCachedTokenInternalPowerAutomateAdmin() {
    return this.getCachedTokenInternal(['https://service.flow.microsoft.com//User']);
  }

  getAccessTokenSilent$(scopes: string[], forceRefresh = false) {
    let r = this.msalService.acquireTokenSilent({
      scopes,
      forceRefresh,
      cacheLookupPolicy: forceRefresh ? CacheLookupPolicy.RefreshTokenAndNetwork : CacheLookupPolicy.Default,
    })
    return r;
  }

  getScopesForEndpoint(endpoint: string): string[] {
    // let scopes = this.msalService.getScopesForEndpoint(endpoint);
    // return scopes.map(scope=> 'https://' + scope.replace('https://', '').replace('//', '/'))
    return null;
  }

  clearCacheForScope(token: any) {
    return null;
  }

  private logMsalEvent(result: EventMessage): void {
    const payload: any = result.payload || {};
    const error: any = result.error || null;
    console.log('[MsalHelper] event', {
      eventType: result.eventType,
      interactionType: result.interactionType,
      errorCode: error?.errorCode,
      errorMessage: error?.errorMessage || error?.message,
      subError: error?.subError,
      accountUsername: payload?.account?.username,
      homeAccountId: payload?.account?.homeAccountId,
      scopes: this.sanitizeScopes(payload?.scopes),
      accountCount: this.msalService.instance.getAllAccounts().length,
      hasActiveAccount: !!this.msalService.instance.getActiveAccount()
    });
  }

  private sanitizeScopes(scopes?: string[]): string[] {
    return (scopes || []).map((scope) => {
      if (!scope) {
        return scope;
      }

      if (scope.startsWith('https://service.flow.microsoft.com')) {
        return scope;
      }

      if (scope.startsWith('https://service.powerapps.com')) {
        return scope;
      }

      if (scope.startsWith('https://graph.microsoft.com')) {
        return scope;
      }

      if (scope.startsWith('api://')) {
        return 'api://...';
      }

      return scope;
    });
  }

  getError() {
    // http://localhost:4200/token#error=invalid_client&error_description=AADSTS650053:+The+application+'Flow+Studio+App'+asked+for+scope+'user_impersonation'+that+doesn't+exist+on+the+resource+'475226c6-020e-4fb2-8a90-7a972cbfc1d4'.+Contact+the+app+vendor.%0D%0ATrace+ID:+528487a4-0eed-4e6f-9ea0-f26a480e1200%0D%0ACorrelation+ID:+996cb131-5c69-4f67-954f-bf45ae29b688%0D%0ATimestamp:+2023-03-02+06:48:34Z&state=3823084a-bc34-4894-ac22-6a5ff38d85df
    var hash = window.location.hash.substr(1); // Remove the "#" character
    var hashArray = hash.split("&"); // Split the string into an array

    var json = {};
    for (var i = 0; i < hashArray.length; i++) {
      var keyValue = hashArray[i].split("="); // Split each item into a key-value pair
      json[keyValue[0]] = keyValue[1]; // Add the key-value pair to the JSON object
    }

    if ('error' in json) {
      return json;
    }
    return null;
  }

  // async server(){

  //   let API_ROOT = "https://management.azure.com/";
  //   let scopes = this.getScopesForEndpoint(API_ROOT);
  //   let token = await this.msalService.acquireTokenSilent(scopes);
  //   //let token = await this.ensureToken(API_ROOT);
  //   return {
  //     'parameters': {
  //       'access_token': token
  //     }
  //   };
  // }

}

const identify = (user) => {
  const USER_ID = `${user['tid']}.${user['oid']}`;


  const { 
    mixpanel, 
    clarity, 
    dataLayer 
  } = <any>window;  

  if (mixpanel) {
    mixpanel.identify(USER_ID);
    mixpanel.people.set({
      "$email": user.username,    // only reserved properties need the $
      //"Sign up date": USER_SIGNUP_DATE,    // Send dates in ISO timestamp format (e.g. "2020-01-02T21:07:03Z")
      "USER_ID": USER_ID,    // use human-readable names
      //"credits": 150    // ...or numbers
      "tid": user['tid'],
      "oid": user['tid'],
      "version": environment.VERSION
    });  
  }

  if (clarity) {
    clarity("set", "USER_ID", user.username);
  }

  let _hsq = (<any>window)._hsq = (<any>window)._hsq || [];
  if (_hsq) {
    _hsq.push(["identify",{
      email: user.username
    }]);
  }

}
